import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
import asyncAwait from 'redux-async-await';
import thunk from 'redux-thunk';

import monitor from './middleware/monitor';
import api from './middleware/api';
import token from './middleware/token';
import refreshROMToken from './middleware/refreshROMToken';
import storyblokMiddleware from './middleware/storyblok/storyblok';

import reducer from '.';

export default (initialState, thunkContext) => {
  const composedMiddleware = composeWithDevTools(
    applyMiddleware(
      asyncAwait,
      api,
      thunk.withExtraArgument(thunkContext),
      token,
      refreshROMToken,
      storyblokMiddleware,
    ),
    monitor,
  );

  return createStore(reducer, initialState, composedMiddleware);
};
